export default __webpack_public_path__ + "static/media/active_status_inactive.4025f38e.svg";